import React, { useRef } from 'react';
import MdEditor from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({ value, onChange, placeholder }) => {
  const editorRef = useRef<MdEditor>(null);

  const handleEditorChange = ({ text }: { text: string }) => {
    onChange(text);
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <MdEditor
        ref={editorRef}
        value={value}
        style={{ height: '300px', width: '100%' }}
        onChange={handleEditorChange}
        placeholder={placeholder || 'Enter description...'}
        renderHTML={(text) => {
          // Preview rendering - actual rendering uses react-markdown on public pages
          return text;
        }}
        config={{
          view: {
            menu: true,
            md: true,
            html: false, // Disable HTML view, we only want markdown
          },
          canView: {
            menu: true,
            md: true,
            html: false,
            fullScreen: false,
            hideMenu: false,
          },
          // Enable link insertion in toolbar
          syncScrollMode: ['rightFollowLeft', 'leftFollowRight'],
        }}
      />
    </div>
  );
};

export default MarkdownEditor;

